import CodebookValueNotFoundError from '../CodebookValueNotFoundError'
import { $t } from '../../composables/i18n'

export enum MealModelId {
  NONE = 1,
  SINGLE = 2,
  SELECTION = 3,
}

export class MealModel {
  private constructor(
    public readonly id: MealModelId,
    public readonly name: () => string,
    public readonly description: () => string,
  ) {}

  static readonly NONE = new MealModel(
    MealModelId.NONE,
    () => $t('None'),
    () => $t('We do not provide any meals with accommodation or only from daily menu'),
  )
  static readonly SINGLE = new MealModel(
    MealModelId.SINGLE,
    () => $t('Single'),
    () => $t('Only the following meal is included in accommodation price'),
  )
  static readonly SELECTION = new MealModel(
    MealModelId.SELECTION,
    () => $t('Selection'),
    () => $t('We offer more types of board'),
  )

  static getById = (id: MealModelId): MealModel => {
    const value = MealModel.all().find((item) => item.id === id)

    if (value === undefined) {
      throw new CodebookValueNotFoundError(MealModel.name, id)
    }

    return value
  }

  static all = (): MealModel[] => {
    return [MealModel.NONE, MealModel.SINGLE, MealModel.SELECTION]
  }
}
